export default __webpack_public_path__ + "static/media/img-43.83bddadc.jpg";